import { AppState } from 'src/app/store'
import {
  ProjectFormDocumentationPayload,
  ProjectTaxDescriptionsPayload,
  ProjectFormStockPayload,
  BillingDataAux,
} from 'src/core/models'


export const projectFormLocationSelector = (state: AppState):
  {latitude: string, longitude: string, country: number} => {
  const projectForm = state.projects.projectForm
  return {
    latitude: projectForm.latitude,
    longitude: projectForm.longitude,
    country: projectForm.country
  }
}


export const billingDataSelector = (state: AppState): BillingDataAux => {
  const form = state.projects.projectForm
  return {
    name: form.billing_company_name,
    idNumber: form.billing_vat_number,
    address: form.billing_address,
    city: form.billing_city,
    state: form.billing_state,
    postalCode: form.billing_postal_code,
    country: form.billing_country
  }
}

export const formContentSelector = (state: AppState) => {
  const form = state.projects.projectForm
  return {
    name: form.name,
    url: form.url,
    sdg_compliances: form.sdg_compliances,
    description_en: form.description_en,
    description_es: form.description_es,
    description_fr: form.description_fr,
    description_ko: form.description_ko,
    description_pt: form.description_pt,
    description_de: form.description_de,
    description_it: form.description_it,
    description_pl: form.description_pl,
    description_zh: form.description_zh,
    registered_since: form.registered_since,
    video: form.video,
    main_image: form.main_image,
    pictures: form.pictures,
    is_tax_relief: form.is_tax_relief,
    headline_en: form.headline_en,
    headline_es: form.headline_es,
    headline_pt: form.headline_pt,
    headline_de: form.headline_de,
    headline_ko: form.headline_ko,
    headline_it: form.headline_it,
    headline_fr: form.headline_fr,
    headline_pl: form.headline_pl,
    headline_zh: form.headline_zh,
  }
}


export const priceStockFormValuesSelector = (state: AppState): ProjectFormStockPayload => {
  const form = state.projects.projectForm
  return {
    currency_token: form.currency_token,
    contribution_unit: form.contribution_unit,
    price: form.price,
    volume_credits: form.volume_credits
  }
}

export const taxRefliefInfoValuesSelector = (state: AppState): ProjectTaxDescriptionsPayload => {
  const form = state.projects.projectForm
  return {
    tax_info_en: form.tax_info_en,
    tax_info_es: form.tax_info_es,
    tax_info_fr: form.tax_info_fr,
    tax_info_ko: form.tax_info_ko,
    tax_info_de: form.tax_info_de,
    tax_info_pt: form.tax_info_pt,
    tax_info_it: form.tax_info_it,
    tax_info_pl: form.tax_info_pl,
    tax_info_zh: form.tax_info_zh
  }
}

export const certificationFormValues = (state: AppState) => {
  const form = state.projects.projectForm
  return {
    credit_end: form.credit_end,
    credit_start: form.credit_start,
    energy_type: form.energy_type,
    first_verifier: form.first_verifier,
    central_name: form.central_name,
    methodology: form.methodology,
    standard: form.standard,
    mechanism: form.mechanism,
    standard_energy_type: form.standard_energy_type,
    status: form.status,
    sub_type: form.sub_type,
    type: form.type,
    validator: form.validator,
    type_of_biome_ecosystem: form.type_of_biome_ecosystem,
    complementary_standards: form.complementary_standards,
    quantification_methodology: form.quantification_methodology,
    stage: form.stage
  }
}

export const documentationFormValues = (state: AppState): ProjectFormDocumentationPayload => {
  const form = state.projects.projectForm
  return {
    registry_depositing_id: form.registry_depositing_id,
    registry_depositing_name: form.registry_depositing_name,
    registry_depositing_url: form.registry_depositing_url,
    credits_certificate: form.credits_certificate,
    pdd: form.pdd,
    validation_report: form.validation_report,
    monitoring_report: form.monitoring_report,
    verification_report: form.verification_report,
    device_registration_request: form.device_registration_request,
    resulting_from_the_issuer: form.resulting_from_the_issuer,
    start_up_date_of_installation: form.start_up_date_of_installation,
    protocol_implementation_scheme: form.protocol_implementation_scheme,
    executive_summary: form.executive_summary,
    additional_documentation: form.additional_documentation,
    insurance_documentation: form.insurance_documentation,
  }
}
